import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
export function EditCoupon() {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const isEdit = !!id;
  return <div className="space-y-4" data-id="element-477">
      <div className="flex items-center justify-between" data-id="element-478">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-479">
          {isEdit ? 'Edit Coupon' : 'Add Coupon'}
        </h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/coupons')} data-id="element-480">
          ← Back to Coupons
        </Button>
      </div>

      <Card data-id="element-481">
        <CardContent className="pt-6" data-id="element-482">
          <form className="space-y-4 max-w-md" data-id="element-483">
            <div data-id="element-484">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-485">
                Coupon Code
              </label>
              <input type="text" defaultValue={isEdit ? 'AN270' : ''} className="h-8 w-full rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-486" />
            </div>
            <div data-id="element-487">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-488">
                Discount Type
              </label>
              <select defaultValue={isEdit ? 'Percentage' : 'Dollar Amount'} className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 w-full" data-id="element-489">
                <option data-id="element-490">Dollar Amount</option>
                <option data-id="element-491">Percentage</option>
              </select>
            </div>
            <div data-id="element-492">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-493">
                Usage Type
              </label>
              <select defaultValue={isEdit ? 'Unlimited by Customer' : 'Per Customer'} className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 w-full" data-id="element-494">
                <option data-id="element-495">Per Customer</option>
                <option data-id="element-496">General Use</option>
                <option data-id="element-497">Unlimited</option>
                <option data-id="element-498">Unlimited by Customer</option>
              </select>
            </div>
            <div data-id="element-499">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-500">
                Group
              </label>
              <select defaultValue="PAR" className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 w-full" data-id="element-501">
                <option data-id="element-502">PAR</option>
                <option data-id="element-503">SAAR</option>
              </select>
            </div>
            <div data-id="element-504">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-505">
                Discount Amount
              </label>
              <input type="text" defaultValue={isEdit ? '100.00' : ''} className="h-8 w-32 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-506" />
            </div>
            <div data-id="element-507">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-508">
                Uses
              </label>
              <input type="text" defaultValue={isEdit ? '0' : ''} className="h-8 w-24 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-509" />
            </div>
            <div data-id="element-510">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-511">
                Expire Date
              </label>
              <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 w-full" data-id="element-512">
                <option data-id="element-513">Not Set</option>
                <option data-id="element-514">Set</option>
              </select>
            </div>
            <div data-id="element-515">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-516">
                Limitations
              </label>
              <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 w-full" data-id="element-517">
                <option data-id="element-518">All Courses/Packages</option>
                <option data-id="element-519">Only Single Course</option>
                <option data-id="element-520">Specific Course</option>
                <option data-id="element-521">Specific Package</option>
              </select>
            </div>
            <div data-id="element-522">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-523">
                Exceed?
              </label>
              <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 w-32" data-id="element-524">
                <option data-id="element-525">No</option>
                <option data-id="element-526">Yes</option>
              </select>
            </div>
            <div className="pt-2" data-id="element-527">
              <Button type="submit" data-id="element-528">Submit</Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>;
}